import PropTypes from 'prop-types';
import React from 'react';
import { inputStyle, labelStyle } from './styles';

const Input = ({
  label,
  type,
  name,
  value,
  onChangeInput,
  placeholder,
  disabled,
}) => (
  <label htmlFor={label} style={labelStyle}>
    <div>{label}</div>
    <input
      style={inputStyle}
      id={label}
      type={type}
      name={name}
      value={value}
      onChange={onChangeInput}
      disabled={disabled}
      aria-label={label}
      placeholder={placeholder}
    />
  </label>
);

Input.propTypes = {
  type: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  onChangeInput: PropTypes.func,
  disabled: PropTypes.bool,
};

Input.defaultProps = {
  disabled: false,
  label: '',
  value: '',
  placeholder: '',
  onChangeInput: () => {},
};

export default Input;
